module.exports = __webpack_public_path__ + "static/media/dig-hero2-v2.f1090d32.png";